<template>
  <v-col
    v-bind="{ ...containerProps, ...containerOptions }"
  >
    <helmi-subheader
      v-if="subheader"
      :colors="labelColors || colors"
      :icon="$attrs.icon"
      :label="$attrs.label"
      class="pa-0 mb-1"
    />
    <v-text-field
      v-model="modelValue"
      v-bind="$attrs"
      placeholder=" "
      :color="colors.base"
      :hide-details="!$attrs.hint && (!$attrs.rules || ($attrs.rules && !$attrs.rules.length))"
      :persistent-hint="persist"
    >
      <template #label>
        <b :class="colors.text">{{ chapter }}</b>
        {{ $attrs.label }}
      </template>
    </v-text-field>
  </v-col>
</template>

<script>
import { EventBus } from '@/utils';

export default {
  name: 'HelmiTextField',

  components: {
    'helmi-subheader': () => import('@/components/formElements/Subheader'),
  },

  inheritAttrs: false,

  props: {
    chapter: {
      type: String,
      default: '',
    },

    colors: {
      type: Object,
      default: () => ({
        base: 'primary',
        text: 'primary--text',
      }),
    },

    containerProps: {
      type: Object,
      default: () => ({}),
    },

    containerOptions: {
      type: Object,
      default: () => ({}),
    },

    labelColors: {
      type: Object,
      default: () => null,
    },

    mask: {
      type: String,
      default: '',
    },

    propertyValue: {
      type: String,
      default: '',
    },

    subheader: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    defaultValue: '',
    modelValue: '',
  }),

  computed: {
    label() {
      return `${this.chapter} ${this.$attrs.label}`;
    },

    persist() {
      return this.$attrs.hint && typeof this.$attrs.hint === 'string';
    },
  },

  watch: {
    // Handles internal model changes.
    modelValue(newVal) {
      this.$emit('input', newVal);
      this.$emit('evaluate', newVal, this.$attrs.id);
    },

    // Handles external model changes.
    '$attrs.value': {
      handler(val) {
        this.modelValue = val;
      },
      immediate: true,
    },
  },

  mounted() {
    EventBus.$on('FORM_RESET', this.resetValue);
  },

  methods: {
    resetValue() {
      this.modelValue = this.propertyValue || this.defaultValue;
    },
  },
};
</script>
